import { ILegalTransactionRelationshipMemberData } from '../../../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationshipMemberData';
import { SignatureCertificationLegalClientRelationshipData } from '../SignatureCertification/SignatureCertificationLegalClientRelationshipData';

export type RelationshipMemberDataViewProps = {
  data: ILegalTransactionRelationshipMemberData;
  setData: (data: ILegalTransactionRelationshipMemberData) => void;
};

export const RelationshipMemberDataView: React.FC<
  RelationshipMemberDataViewProps
> = ({ data, setData }) => {
  console.log('RelationshipMemberDataView', data);
  if (data.type === 'signatureCertification') {
    return (
      <SignatureCertificationLegalClientRelationshipData
        signatureCertificationData={data}
        setSignatureCertificationData={setData}
      />
    );
  }

  return null;
};
